
<template>
  <div class="flex relative" @click="onClick">
    <div class="" :style="{ maxWidth: leftMaxWidth, width: leftWidth }">
      <slot name="left"> </slot>
    </div>

    <div
      class="my-auto"
      :style="{ maxWidth: middleMaxWidth, width: middleWidth }"
    >
      <div class="my-auto">
        <slot></slot>
      </div>
      <div class="">
        <slot name="description"></slot>
      </div>
    </div>
    <div
      class="ml-auto"
      :style="{ maxWidth: rightMaxWidth, width: rightWidth }"
    >
      <slot name="right"> </slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ListItemLayout',
  props: {
    leftMaxWidth: {
      type: String,
      default: 'auto'
    },
    leftWidth: {
      type: String,
      default: 'auto'
    },
    middleMaxWidth: {
      type: String,
      default: 'auto'
    },
    middleWidth: {
      type: String,
      default: 'auto'
    },
    rightMaxWidth: {
      type: String,
      default: 'auto'
    },
    rightWidth: {
      type: String,
      default: 'auto'
    },
    clickable: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      default: () => {
        console.log('clicked');
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  watch: {}
});
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  